import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getAPIHost } from '@rsos/base-utils/metaTags';
import type { StateWithPsaps } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';

export interface DebugPanelConfig {
  baseUrl: string;
  accountId: string;
  isLocal: boolean;
}

/**
 * Hook to get config with account ID from Redux state
 */
export const useDebugPanelConfig = (): DebugPanelConfig => {
  const psapInfo = useSelector(
    (state: StateWithPsaps) => state.psaps.currentPSAP,
  );
  const accountId = psapInfo?.account_id || 'DEMO';

  const baseUrl = getAPIHost();
  const isLocal =
    baseUrl.includes('localhost') ||
    baseUrl.includes('127.0.0.1') ||
    baseUrl.includes('devbox');

  return useMemo(
    () => ({
      baseUrl,
      accountId,
      isLocal,
    }),
    [baseUrl, accountId, isLocal],
  );
};
